var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{attrs:{"r":"8","cx":"50%","cy":"50%","stroke-dasharray":"0 50"}})}
var staticRenderFns = []

export { render, staticRenderFns }